// RoleService.js

import axios from 'axios';
import { URL } from "../config";
const BASE_URL = URL;

const roleService = {
  getAllRoles: async () => {
    try {
      const response = await axios.get(`${BASE_URL}/roles`);
      return response.data?.data || response.data;
    } catch (error) {
      throw new Error(`Error fetching roles: ${error.message}`);
    }
  },

  createRole: async (roleData) => {
    try {
      const response = await axios.post(`${BASE_URL}/roles`, roleData);
      return response.data?.data || response.data;
    } catch (error) {
      throw new Error(`Error creating role: ${error.message}`);
    }
  },

  updateRole: async (roleId, roleData) => {
    try {
      const response = await axios.put(`${BASE_URL}/roles/${roleId}`, roleData);
      return response.data?.data || response.data;
    } catch (error) {
      const apiMessage = error.response?.data?.message;
      throw new Error(apiMessage || `Error updating role: ${error.message}`);
    }
  },

  deleteRole: async (roleId) => {
    try {
      const response = await axios.delete(`${BASE_URL}/roles/${roleId}`);
      return response.data;
    } catch (error) {
      throw new Error(`Error deleting role: ${error.message}`);
    }
  },

  assignUserToRole: async (roleId, userId) => {
    try {
      const response = await axios.put(`${BASE_URL}/roles/${roleId}/assignUser`, {
        userId: userId
      });
      return response.data?.data || response.data;
    } catch (error) {
      throw new Error(`Error assigning user to role: ${error.message}`);
    }
  },

  removeUserFromRole: async (roleId, userId) => {
    try {
      const response = await axios.put(`${BASE_URL}/roles/${roleId}/removeUser`, {
        userId: userId
      });
      return response.data?.data || response.data;
    } catch (error) {
      throw new Error(`Error removing user from role: ${error.message}`);
    }
  },

  removePermissionFromRole: async (roleId, permissionId) => {
    try {
      const response = await axios.put(`${BASE_URL}/roles/${roleId}/removePermission`, {
        permissionId: permissionId
      });
      return response.data?.data || response.data;
    } catch (error) {
      throw new Error(`Error removing permission from role: ${error.message}`);
    }
  },

  assignPermissionsToRole: async (roleId, permissionIds) => {
    try {
      const response = await axios.put(`${BASE_URL}/roles/${roleId}/assignPermissions`, {
        permissionIds
      });
      return response.data?.data || response.data;
    } catch (error) {
      throw new Error(`Error assigning permissions to role: ${error.message}`);
    }
  },
};

export default roleService;
